var React = require('react');

function IconPurchaseProtection (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4"},[React.createElement("path",{"d":"m64 44.59 6.42 12.36 13.99 2.47-10.02 9.74 2.22 14.25-12.61-6.7-12.61 6.7 2.22-14.25-10.02-9.74 13.99-2.47z","key":0}),React.createElement("path",{"d":"m62.82 21.79c-5.82 6-17.53 9.79-31.33 10.12h-1.58l-.33 1.55a179.67 179.67 0 0 0 -3 20.4c-.84 9-1.52 25.51 3.35 34.53 3.63 6.73 14.85 13.27 19.51 15.77a133.12 133.12 0 0 0 13.87 6.47l.69.37.73-.29a133.12 133.12 0 0 0 13.87-6.47c4.66-2.5 15.88-9 19.51-15.77 4.87-9 4.19-25.51 3.35-34.53a179.2 179.2 0 0 0 -3-20.41l-.33-1.54h-1.58c-13.55-.41-25.11-4.19-30.85-10.19l-1.44-1.5z","key":1})]));
}

IconPurchaseProtection.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = IconPurchaseProtection;

IconPurchaseProtection.default = IconPurchaseProtection;
